/* eslint-disable */
import { createStyles } from "@material-ui/styles";
import { Theme, makeStyles } from "@material-ui/core";

export const styles = (theme: Theme) =>
  createStyles({
    icon: {
      width: theme.spacing(2),
      height: theme.spacing(2),
      padding: theme.spacing(0.5, 1, 0.5, 1),
      boxSizing: 'content-box',
      "&.focus": { 
        '& *': {
          stroke: theme.palette.primary.main,
        }
      }
    }
  });
export const useStyles = makeStyles(styles);

export const stylesField = (theme: Theme) =>
  createStyles({
    root: {
      marginLeft: theme.spacing(1),
      width: theme.spacing(20),
      cursor: 'pointer',
    }
  });
export const useStylesField = makeStyles(stylesField);

export const stylesInput = (theme: Theme) =>
  createStyles({
    root: {
      cursor: 'pointer',
      background: "rgba(43, 57, 64, 0.07)",
      borderColor: "rgba(43, 57, 64, 0.07)",
      borderRadius: "3px",
      borderStyle: "solid",
      borderWidth: "1px",
      "&:before": {
        display: "none"
      },
      "&:after": {
        display: "none"
      },
      "&.focus": {
        borderColor: theme.palette.primary.main
      }
    },
    formControl: {},
    focused: {},
    disabled: {},
    underline: {},
    error: {},
    multiline: {},
    fullWidth: {},
    input: {
      cursor: 'pointer',
      padding: theme.spacing(1),
      color: "transparent",
      textShadow: "0 0 0 #2B3940",
      userSelect: "none",
      fontSize: '14px',
      lineHeight: '17px',
    },
    inputMarginDense: {},
    inputMultiline: {},
    inputTypeSearch: {}
  });

export const useStylesInput = makeStyles(stylesInput);

export const stylesLabel = (theme: Theme) =>
  createStyles({
    root: {
      fontSize: "14px",
      lineHeight: "16px",
      color: "rgba(43, 57, 64, 0.5)",
      "&.focus": {
        color: theme.palette.primary.main + ' !important'
      }
    },
    focused: {
      color: "rgba(43, 57, 64, 0.5) !important"
    },
    disabled: {},
    error: {},
    required: {},
    asterisk: {},
    formControl: {},
    marginDense: {},
    shrink: {
      color: "rgba(43, 57, 64, 0.5)"
    },
    animated: {},
    filled: {},
    outlined: {}
  });

export const useStylesLabel = makeStyles(stylesLabel);